import { useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Input } from "@/pages/Login";
import { ArrowRight, MailCheck } from "lucide-react";
import { toast } from "sonner";

export default function ForgotPassword() {
  const { forgotPassword } = useAuth();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const res = await forgotPassword(email);
    setLoading(false);
    if (res.ok) setSent(true);
    else toast.error(res.error);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-bone px-6" data-testid="forgot-password-page">
      <div className="w-full max-w-md">
        <Link to="/" className="block"><img src="/logo.png" alt="In His Image Movement Ministries" className="h-24 w-auto object-contain mx-auto" /></Link>

        {sent ? (
          <div className="text-center mt-10" data-testid="forgot-sent">
            <div className="inline-flex items-center justify-center w-16 h-16 border border-navy/20 bg-navy/5 rounded-full">
              <MailCheck size={26} className="text-navy" strokeWidth={1.5} />
            </div>
            <h1 className="font-serif font-light text-4xl mt-8 tracking-tight">Check your inbox.</h1>
            <p className="font-sans text-charcoal/60 mt-4">
              If an account exists for <span className="text-charcoal font-medium">{email}</span>, we've sent a link to reset your password. It expires in 1 hour.
            </p>
            <p className="font-sans text-sm text-charcoal/60 mt-8">
              <Link to="/login" className="text-olive border-b border-olive/40">Back to sign in</Link>
            </p>
          </div>
        ) : (
          <>
            <h1 className="font-serif font-light text-4xl mt-10 tracking-tight text-center">Reset your password.</h1>
            <p className="font-sans text-charcoal/60 mt-3 text-center">Enter your email and we'll send you a reset link.</p>
            <form onSubmit={submit} className="space-y-6 mt-10">
              <Input label="Email" type="email" value={email} onChange={setEmail} testid="forgot-email" />
              <button type="submit" disabled={loading} data-testid="forgot-submit"
                className="group w-full bg-charcoal text-bone py-4 font-mono text-xs uppercase tracking-widest hover:bg-olive transition-colors flex items-center justify-center gap-3 disabled:opacity-50">
                {loading ? "Sending..." : "Send Reset Link"} <ArrowRight size={16} className="hover-arrow" />
              </button>
            </form>
            <p className="font-sans text-sm text-charcoal/60 mt-8 text-center">
              Remembered it? <Link to="/login" className="text-olive border-b border-olive/40">Sign in</Link>
            </p>
          </>
        )}
      </div>
    </div>
  );
}
